module.exports = __webpack_public_path__ + "public/SiteIcons/location.svg?2f2d2489";